import { HLS_PLAYER_ID } from '@utils/vars'

export const getHlsPlayerElement = (): HTMLVideoElement | null => {
  return <HTMLVideoElement>document.getElementById(HLS_PLAYER_ID)
}
